function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.0523 5.23683C13.3086 5.23683 14.5134 5.73589 15.4017 6.62422C16.2901 7.51255 16.7891 8.71739 16.7891 9.97368V15.5H13.6312V9.97368C13.6312 9.55491 13.4649 9.1533 13.1688 8.85719C12.8726 8.56108 12.471 8.39473 12.0523 8.39473C11.6335 8.39473 11.2319 8.56108 10.9358 8.85719C10.6397 9.1533 10.4733 9.55491 10.4733 9.97368V15.5H7.31543V9.97368C7.31543 8.71739 7.81449 7.51255 8.70282 6.62422C9.59115 5.73589 10.796 5.23683 12.0523 5.23683V5.23683Z",
  stroke: "#CECECE",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M4.1579 6.02629H1V15.5H4.1579V6.02629Z",
  stroke: "#CECECE",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M2.57895 3.6579C3.45098 3.6579 4.1579 2.95098 4.1579 2.07895C4.1579 1.20692 3.45098 0.5 2.57895 0.5C1.70692 0.5 1 1.20692 1 2.07895C1 2.95098 1.70692 3.6579 2.57895 3.6579Z",
  stroke: "#CECECE",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgLogoLinkedin = function SvgLogoLinkedin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoLinkedin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo_linkedin.77134693.svg";
export { ForwardRef as ReactComponent };